import { Component } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  templateUrl: 'w2g-popover.component.html',
  styleUrls: ['./w2g-popover.component.scss'],
})

export class W2GPopoverComponent {
  public consent;
  public canSave: boolean = false;
  public callBackFn: any;

  constructor(
    private appLinksService: AppLinksService,
    public navigator: Navigator,
    public userProvider: UserSessionService,
    public authenticationProvider: AuthenticationService,
    public navParams: NavParams) {
    this.callBackFn = this.navParams.get('callBackFn');
  }

  yesSelect() {

    let customer_consent: any = [];
    customer_consent['propName'] = "W2G_ELECTRONIC_MAIL_CONSENT";
    customer_consent['propValue'] = true;

    this.authenticationProvider.updateCustomData(customer_consent).subscribe(
      (resp) => {
        this.userProvider.refreshCustomer();
      });

    let callBackFn = this.navParams.get('callBackFn');
    if (!!callBackFn) {
      this.callBackFn();
    } else {
      this.navigator.dismiss();
    }
  }

  navigateTo(pagename: string, multipleModals: boolean): any {
    return this.navigator.navigateTo(pagename, { multipleModals: multipleModals });
  }

  noSelect = () => {
    this.consent = "false";
    let customer_consent: any = [];
    customer_consent['propName'] = "W2G_ELECTRONIC_MAIL_CONSENT";
    customer_consent['propValue'] = false;

    this.authenticationProvider.updateCustomData(customer_consent).subscribe(
      (resp) => {
        this.userProvider.refreshCustomer();
      });
    if (!!this.callBackFn) {
      this.callBackFn();
    } else {
      this.navigator.dismiss();
    }
  }

  closeModal() {
    this.noSelect();
  }

  public openMatchedExternalLinks(code, title) {
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

}